export default {
  limitMessagesCase: null,
  userByPassMessagesLimit: null,
  organizationSlug: null,
  organizationClientSlug: null,
  organizationKey: null,
  language: null,
  widgetMode: null,
  chatMode: null,
  introType: null,
  isPopoverChatOpen: false,
  autoOpenPopoverChat: false,
  openPopoverChatOnClickthrough: false,
  showSendChatModal: false,
}
